import {
  assertUniqueName,
  clientPath,
  LpBackendError,
  lpRequest,
  userId
} from '../../../../core/utils/lp-backend';
import { getBranch } from './get-branch';

/**
 * `POST /client/:cid/branch/` (multipart, the logo as `image`), then `PATCH /client/:cid/branches/:id
 * {dashboard_url}`: the existing create does not write `dashboard_url`.
 */
export const createBranch = async (
  hub_id: string,
  name: string,
  contact: string,
  store_code: string,
  dashboard_url: string,
  address: string,
  location: any,
  branch_logo?: File | null
): Promise<any> => {
  assertUniqueName((await lpRequest('GET', clientPath('/branch'))) || [], name, 'branch');

  const formData = new FormData();
  formData.append('hub_id', hub_id);
  formData.append('name', name);
  formData.append('contact', contact || '');
  formData.append('store_code', store_code || '');
  formData.append('address', address);
  formData.append('latitude', String(location?.latitude ?? location?.lat));
  formData.append('longitude', String(location?.longitude ?? location?.lng));
  formData.append('user_id', userId());
  if (branch_logo) {
    formData.append('image', branch_logo);
  }

  const { id } = await lpRequest('POST', clientPath('/branch/'), { form: formData });

  // The branch exists from here on: a failed follow-up must not read as a failed create, or a retry duplicates it.
  if (dashboard_url) {
    try {
      await lpRequest('PATCH', clientPath(`/branches/${id}`), { body: { dashboard_url } });
    } catch (err) {
      throw new LpBackendError(
        `The branch was created, but its dashboard URL was not saved: ${
          (err as Error).message
        } Edit the branch to add it.`,
        (err as LpBackendError).status ?? 0
      );
    }
  }

  try {
    return await getBranch(id);
  } catch (err) {
    throw new LpBackendError(
      'The branch was created, but it could not be loaded. Open it from the branch list.',
      (err as LpBackendError).status ?? 0
    );
  }
};
